export {
  isCardContentKindAllowedInStudyEnvironment,
  STUDY_ENVIRONMENTS,
  type StudyEnvironment,
  studyEnvironmentDescription,
  studyEnvironmentLabel,
  studyEnvironmentStudyMode,
} from "#study-environment";
